import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import TwilioSubaccountComponent from '../../components/TwilioSubaccount/TwilioSubaccount';
import TwilioApiKeysComponent from '../../components/TwilioApiKeys/TwilioApiKeys';
import TwilioPhoneNumbersComponent from '../../components/TwilioPhoneNumbers/TwilioPhoneNumbers';
import TwilioMessagesComponent from '../../components/TwilioMessages/TwilioMessages';

const TwilioTab: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = React.useState<string>('subaccount');
  const tabs = ['subaccount', 'apikeys', 'phonenumbers', 'messages'];
  const tabLabels = {
    subaccount: 'Subaccount',
    apikeys: 'API Keys',
    phonenumbers: 'Phone Numbers',
    messages: 'Messages'
  };

  React.useEffect(() => {
    const hash = location.hash.replace('#', '');
    if (hash && tabs.includes(hash)) {
      setActiveTab(hash);
    }
  }, [location.hash]);

  const handleTabChange = (newValue: string) => {
    setActiveTab(newValue);
    navigate(`${location.pathname}#${newValue}`);
  };

  const goToPreviousTab = () => {
    const currentIndex = tabs.indexOf(activeTab);
    if (currentIndex > 0) {
      handleTabChange(tabs[currentIndex - 1]);
    }
  };

  const goToNextTab = () => {
    const currentIndex = tabs.indexOf(activeTab);
    if (currentIndex < tabs.length - 1) {
      handleTabChange(tabs[currentIndex + 1]);
    }
  };

  const getCurrentTabIndex = () => {
    return tabs.indexOf(activeTab) + 1;
  };

  return (
    <div className="container mx-auto">
      <div className="w-full">
        {/* Desktop Tabs */}
        <div className="hidden md:block border-b border-gray-200">
          <nav className="flex space-x-8" aria-label="Tabs">
            {tabs.map(tab => (
              <button
                key={tab}
                onClick={() => handleTabChange(tab)}
                className={`py-4 px-1 border-b-2 font-medium text-sm ${activeTab === tab
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
              >
                {tabLabels[tab as keyof typeof tabLabels]}
              </button>
            ))}
          </nav>
        </div>

        {/* Mobile Tab Navigation */}
        <div className="block md:hidden border-b border-gray-200">
          <div className="flex items-center justify-between py-2">
            <button
              onClick={goToPreviousTab}
              disabled={tabs.indexOf(activeTab) === 0}
              className={`p-2 rounded-full ${tabs.indexOf(activeTab) === 0 ? 'text-gray-300' : 'text-blue-600'}`}
            >
              ←
            </button>
            <div className="font-medium">
              {tabLabels[activeTab as keyof typeof tabLabels]} ({getCurrentTabIndex()}/{tabs.length})
            </div>
            <button
              onClick={goToNextTab}
              disabled={tabs.indexOf(activeTab) === tabs.length - 1}
              className={`p-2 rounded-full ${tabs.indexOf(activeTab) === tabs.length - 1 ? 'text-gray-300' : 'text-blue-600'}`}
            >
              →
            </button>
          </div>
        </div>

        <div className="mt-6">
          {activeTab === 'subaccount' && (
            <TwilioSubaccountComponent />
          )}

          {activeTab === 'apikeys' && (
            <TwilioApiKeysComponent />
          )}

          {activeTab === 'phonenumbers' && (
            <TwilioPhoneNumbersComponent />
          )}

          {activeTab === 'messages' && (
            <TwilioMessagesComponent />
          )}
        </div>
      </div>
    </div>
  );
};

export default TwilioTab; 